import React, { memo, useEffect, useMemo } from 'react'
import styles from '../../../../Styles/index.module.scss'
import { useAppDispatch } from '../../../../../../../hooks/useAppDispatch'
import { PATH_JOINER } from '../../../../../utils/getConfigBitPath'
import { createPluginSchedule, PluginSchedule } from '../../../SchedulesContainer/lib/PluginSchedule'
import { addItemToArrayEnd } from '../../../../../../../store/actions/ruleCardActions'
import { ruleCardActions } from '../../../../../../../store/slices/ruleCardSlice'
import { NoData } from '../../../../../../NoData'
import { ViewOnlyWrapper } from '../../../../../../ViewOnly/ViewOnlyWrapper'
import AppButton from '../../../../../../buttons/AppButton/AppButton'
import { RuleScheduleBlock } from './RuleScheduleBlock'

interface Props {
    schema: any
    config: any
    dataPath: string
    pathWithElementID: string | undefined
    element_id?: string
    wrapper?: string
    levelDeep?: number
    isViewOnly?: boolean
    inCard?: boolean
    isRuleActive?: boolean
    isParentDisabled?: boolean
}

export const RuleSchedulesContainer = memo(function RuleSchedulesContainer({
    schema,
    config,
    dataPath,
    pathWithElementID,
    inCard,
    isRuleActive,
    isViewOnly,
}: Props) {
    const dispatch = useAppDispatch()
    const path = useMemo(
        () => [...(dataPath?.length ? dataPath.split(PATH_JOINER) : [])],
        [dataPath]
    )
    const errorKeyName = pathWithElementID ?? ''
    const componentSchema = schema.children?.children || schema.children

    const addSchedule = () => {
        dispatch(addItemToArrayEnd({ path, data: createPluginSchedule() }))
    }

    useEffect(() => {
        if (!config?.length) {
            dispatch(
                ruleCardActions.setRuleConfigInvalid({ errorKeyName })
            )
        }
        if (config?.length) {
            dispatch(
                ruleCardActions.setRuleConfigValid({ errorKeyName })
            )
        }
    }, [config?.length, errorKeyName, dispatch])

    const schedules = config?.map((schedule: PluginSchedule, index: number) => (
        <RuleScheduleBlock
            key={schedule.element_id}
            scheduleSchema={componentSchema}
            schedule={schedule}
            schedules={config}
            dataPath={path}
            pathWithElementID={pathWithElementID}
            index={index}
            inCard={inCard}
            isRuleActive={isRuleActive}
        />
    ))

    const noSchedules = !config?.length ? (
        <>
            <NoData
                style={{ height: '60px' }}
                messageId={'errors.messages.noSchedule'}
            />
            <div className="app-color-red p-1 m-2 text-center">
                At least 1 schedule required
            </div>
        </>
    ) : (
        <></>
    )

    return (
        <ViewOnlyWrapper
            disableEvents={!!isViewOnly}
            className={styles.container}
        >
            {schedules}
            {noSchedules}
            <AppButton
                variant="add"
                onClick={addSchedule}
                tooltip="Add schedule"
                className={`m-auto hover`}
            />
        </ViewOnlyWrapper>
    )
})
